module.exports = __webpack_public_path__ + "static/media/icon_bot_transfer_orange.be50c134.svg";